export enum AppIcon {
  arrowRight = 'arrowRight',
  arrowBack = 'arrowBack',
  arrowLeft = 'arrowLeft',
  arrowNext = 'arrowNext',
  menu = 'menu',
  plus = 'plus',
  waitlist = 'waitlist',
  billing = 'billing',
  notifications = 'notifications',
  schedules = 'recent',
  circle = 'circle',
  time = 'time',
  sorting = 'sorting',
  arrowUp = 'arrow-up',
  arrowDown = 'arrow-down',
  floorPlan = 'floorPlan',
  discount = 'discount',
  togo = 'togo',
  download = 'download',
  services = 'services',
  analytics = 'analytics',
  reservations = 'reservations',
  reservationOptions = 'reservations',
  settings = 'settings',
  resources = 'resources',
  admin = 'admin',
  automations = 'automations',
  plans = 'plans',
  publicPages = 'publicPages',
  alerts = 'alerts',
  grid = 'grid',
  integrations = 'integrations',
  waitlistOptions = 'waitlistOptions',
  appearance = 'appearance',
  accountInfo = 'account',
  call = 'call',
  password = 'password',
  customers = 'users',
  users = 'users',
  print = 'print',
  locations = 'locations',
  location = 'location',
  logout = 'logout',
  guide = 'waitlist',
  check = 'check',
  send = 'send',
  complete = 'complete',
  recent = 'recent',
  delete = 'delete',
  edit = 'edit',
  multiSelect = 'select-all',
  exclamation = 'exclamation',
  search = 'search',
  addUser = 'addUser',
  userCount = 'userCount',
  date = 'waitlist',
  cancel = 'cancel',
  import = 'import',
  export = 'export',
  info = 'info',
  infoHeavy = 'info-heavy',
  settings2 = 'settings-2',
  square = 'square',
  webhooks = 'webhooks',
  chat = 'chat',
  question = 'question',
  document = 'document',
  organization = 'organization',
  externalLink = 'external-link',
  sortableUp = 'sortable-up',
  sortableDown = 'sortable-down',
  whatsapp = 'whatsapp',
  flame = 'flame',
  fastForward = 'fast-forward',
  speechBubbleWithDots = 'speech-bubble-with-dots',
  announce = 'announce',
  partyFields = 'partyFields',
  stripeLogo = 'stripe-logo',
  key = 'key',
}

export enum AppIconSize {
  minuscule = '6',
  tiny = '8',
  small = '12',
  belowAverage = '14',
  regular = '16',
  medium = '20',
  large = '24',
  extraLarge = '32',
}

export enum AppIconColor {
  green = '#0EAD69',
  blue = '#3A74CB',
  white = '#fff',
  orange = '#DE8500',
  lightPrimary = '#77889A',
  primary = '#4B5574FF',
  black = '#000000FF',
  danger = '#ee4266',
}
